module.exports = __webpack_public_path__ + "img/button.25fef4be.svg";